module.exports = __webpack_public_path__ + "static/Gotham-BoldItalic-ef9a499a0a4ad6639757ea7480e0d26e.ttf";